import { useState } from "react";
import useFetchStructure from "./useFetchStructure";
import { fMpathConstants } from "../fileManagerConstants";

const useAdditionalFilters = () => {
  const { data: FMSFolderStructure } = useFetchStructure({
    queryKey: ['fm-folder-structure'], 
    payload: {}, 
    path: fMpathConstants.FMGetCategory, 
    enabled: true
  });
  const [categoryInputValue, setCategoryInputValue] = useState<string>('');
  const [subCategoryInputValue, setSubCategoryInputValue] = useState<string>('');
  return {
    FMSFolderStructure,
    categoryInputValue,
    subCategoryInputValue,
    setCategoryInputValue,
    setSubCategoryInputValue
  }
}

export default useAdditionalFilters;